<template>
    <!-- Toast 消息 -->
    <div v-if="showToast"
        class="fixed left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 text-white py-3 px-6 rounded-md shadow-lg z-50 transition-opacity duration-500 flex items-center justify-center"
        :style="{ background: toastBgColor }" :class="{ 'opacity-0': toastFading }">
        {{ toastMessage }}
    </div>
</template>

<script setup lang="ts">
    const showToast = ref(false)
    const toastFading = ref(false)
    const toastMessage = ref('')
    const toastBgColor = ref('rgba(21,143,67,0.95)') // 默认绿色（成功）

    // 内部：显示Toast的基础逻辑
    function showToastBase(message: string, bgColor: string) {
        toastMessage.value = message
        toastBgColor.value = bgColor
        showToast.value = true
        toastFading.value = false

        // 5秒后开始淡出
        setTimeout(() => {
            toastFading.value = true

            // 淡出动画完成后隐藏Toast
            setTimeout(() => {
                showToast.value = false
            }, 500)
        }, 5000)
    }

    // 显示成功消息（绿色背景）
    function showSuccess(message: string) {
        showToastBase(message, 'rgba(21,143,67,0.95)')
    }

    // 显示错误消息（红色背景）
    function showFail(message: string) {
        showToastBase(message, 'rgba(220,38,38,0.95)')
    }
    
    defineExpose({
        showSuccess,
        showFail
    })

</script>

<style scoped lang="scss">

</style>
